// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/images/grid.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/images/bg-transparent.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/public/images/line.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/public/images/circle-one.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("/public/images/star-empty.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("/public/images/star-filled.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App-content {
  position: relative;
  z-index: 1;
  padding-bottom: 1.5rem;
  min-height: 76vh;
}
.topbar-wp {
  position: relative;
  background-color: #000;
  z-index: 3;
}
header {
  position: relative;
}
.logo-wp {
  display: flex;
  justify-content: center;
  align-items: center;
}

footer {
  position: relative;
}

.orange {
  color: #f1b24f;
}

.btn-orange {
  background-color: #f1b24f !important;
}

.desc {
  --text-opacity: 1;
  color: rgb(75 85 99 / var(--text-opacity));
}

.bg {
  width: 100%;
  min-height: 100vh;
  position: fixed;
  display: flex;
  justify-content: center;
  padding: 120px 24px 160px;
  pointer-events: none;
}
.noclick {
  pointer-events: none;
}
.clickable {
  pointer-events: all;
}
.bg::after,
.bg::before {
  position: absolute;
  content: "";
  width: 100%;
  height: 100%;
  top: 0;
}

.bg::before {
  background: radial-gradient(circle, rgba(2, 0, 36, 0) 0, #fafafa 100%);
  z-index: 2;
}

.bg::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  z-index: 1;
  opacity: 0.4;
  filter: invert(1);
}

.gradient {
  height: -moz-fit-content;
  height: fit-content;
  z-index: 3;
  max-width: 640px;
  background-image: radial-gradient(at 27% 37%, #fcb034 0, transparent 0),
    radial-gradient(at 97% 21%, #72fe7d 0, transparent 50%),
    radial-gradient(at 52% 99%, #fd3a4e 0, transparent 50%),
    radial-gradient(at 10% 29%, #855afc 0, transparent 50%),
    radial-gradient(at 97% 96%, #e4c795 0, transparent 50%),
    radial-gradient(at 33% 50%, #8ca8e8 0, transparent 50%),
    radial-gradient(at 79% 53%, #eea5ba 0, transparent 50%);
  position: absolute;
  content: "";
  width: 100%;
  height: 100%;
  filter: blur(100px) saturate(10%);
  top: 80px;
  opacity: 0.1;
}

.box {
  max-width: 840px;
  min-width: 840px;
  height: 100%;
  min-height: 440px;
  border-radius: 20px;
  padding: 1rem 3rem;
  border: 1px solid #000 !important;
  display: flex;
  justify-content: center;
  align-items: center;
}

.box.upload {
  --bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--bg-opacity));
}

.card-group {
  width: 100%;
}

/*Modal*/
.modal {
  display: none;
  position: fixed;
  /* z-index: 1; */
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
}

.modal.open {
  display: block;
}
.product-logo-box {
  height: 100%;
  min-height: 35vh;
  min-width: 25vw;
}
.product-logo-box.solo {
  width: 28vw;
  min-height: 35vh;
}
#advanceImage .modal-content {
  margin: 50px auto;
}
.modal-content {
  background-color: #fefefe;
  margin: 10% auto;
  padding: 20px;
  width: 100%;
}

.close {
  color: #aaa;
  float: initial;
  font-size: 28px;
  font-weight: bold;
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 8px;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}
.card-custom {
  width: 350px;
  height: auto;
}
.card-custom2 {
  height: 20rem;
}

.image-preview {
  width: 100%;
  height: 290px;
  object-fit: contain;
}
.filter-0 {
  filter: brightness(0%);
}
.filter-100 {
  filter: brightness(100%);
}

.filter-100 {
  filter: brightness(100%);
}
.image-preview.three {
  width: 100%;
  height: 290px;
  object-fit: contain;
}
.image-preview-gray {
  filter: invert(57%) sepia(3%) saturate(27%) hue-rotate(4deg) brightness(10%)
    contrast(89%);
}
.preview-image-background {
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.margin-auto {
  margin: 1rem 0 !important;
}
/*Customize Checkbox*/
.checkbox-cont {
  display: block;
  position: relative;
  padding-left: 31px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 15px;
  -webkit-user-select: none;
  user-select: none;
}

.checkbox-cont input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #eee;
}

.checkbox-cont:hover input ~ .checkmark {
  background-color: #ccc;
}

.checkbox-cont input:checked ~ .checkmark {
  background-color: #fcb034;
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.checkbox-cont input:checked ~ .checkmark:after {
  display: block;
}

.checkbox-cont .checkmark:after {
  left: 10px;
  top: 7px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  transform: rotate(45deg);
}

img.card-img-top {
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
  max-height: 200px;
  min-height: 200px;
  border-radius: 7px;
}
.card-img-top-download {
  max-width: 330px;
  max-height: 260px;
  min-height: 260px;
  border-radius: 7px;
}

.container {
  position: relative;
  z-index: 0;
}

.customize {
  position: fixed !important;
  min-height: 133vh;
  overflow: hidden !important;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: -1;
}

._loading_overlay_wrapper--active {
  z-index: 11 !important;
}

.check {
  color: #f1b24f;
  font-size: 3rem;
  font-weight: bold;
  position: absolute;
  top: -15px;
  left: 5px;
  display: none;
}
.check-mark {
  width: 45px;
  height: 45px;
  border-radius: 10px;
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: #fff;
  border: 1px solid #000;
}
.check-mark.brand {
  background-color: transparent;
}
.check-mark.selected .check {
  display: block;
}
.step-one-label {
  font-weight: bold;
}
.info-label {
  font-size: 15px;
  width: 350px;
}
.disclaimer-cont {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.disclaimer-cont .h-50 {
  height: 500px;
}
.disclaimer-text {
  text-align: center;
  font-style: italic;
  font-weight: bold;
  width: 40%;
  margin-top: 1rem;
  max-width: 100%;
}
.space-between {
  justify-content: space-between;
}
.guide-wp {
  top: 1rem;
  right: 3.5rem;
}
.guide {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10%;
  padding: 0.2rem;
}
.guide.tutorial:hover .tooltip {
  visibility: visible;
  opacity: 1;
}
.tutorial-wp:hover .tutorial .tooltip {
  visibility: visible;
  opacity: 1;
}
.tooltip {
  visibility: hidden;
  position: absolute;
  top: 20px; /* Adjust the position as needed */
  left: -10%;
  transform: translateY(50%);
  background-color: white;
  color: black;
  border-radius: 10px;
  padding: 5px 10px;
  font-size: 12px;
  border: 1px solid #ccc; /* Light border for contrast */
  z-index: 1;
  opacity: 0;
  transition: opacity 0.3s ease;
}
.question {
  width: 30px;
  height: 30px;
}
.guide-modal .bold {
  font-weight: bold;
}

.guide-modal .modal-header {
  display: block;
  border-bottom: none;
}
.guide-modal .modal-title {
  text-align: center;
  color: black;
  position: relative;
}
.guide-modal .modal-title::after {
  content: "";
  position: absolute;
  width: 356px;
  height: 30px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  right: 33%;
  top: 35px;
}
.guide-modal .circle {
  position: relative;
}
.guide-modal .circle::after {
  content: "";
  position: absolute;
  width: 408.38px;
  height: 100px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-repeat: no-repeat;
  right: 27%;
  top: -40px;
}

.guide-modal .btn-close {
  position: absolute;
  top: 15px;
  right: 15px;
}
.info-desc {
  padding: 0.5rem 0.6rem;

  border-radius: 10px;
}
.info-desc p {
  font-size: 14px;
}

.new {
  position: relative;
  color: #fff;
  background-color: #ffcc00;
  margin-left: 1rem;
  display: block;
  font-size: 0.8rem;
  text-align: center;
  border-radius: var(--bs-card-border-radius);
  padding: 0.1rem 1.2rem;
  margin-top: 1rem;
}
.new::after {
  content: "";
  position: absolute;
  top: 65%;
  left: 3.3px;
  background-color: #ffcc00;
  border: 1px solid #ffcc00;
  width: 15px;
  height: 15px;
  transform: rotate(45deg);
  border-top: none;
  border-left: none;
}
.modal-iframe .modal-dialog {
  max-width: 100%;
  height: 100%;
}

iframe.preview-iframe {
  width: 100%;
  height: 75vh;
}
.add-image-icon {
  width: 70px;
  height: 70px;
}
.preview-catalog {
  width: 100%;
  text-align: center;
  background: #f1b24f;
  border-radius: 7px;
  padding: 0.5rem;
  color: #fff;
  font-weight: bold;
  font-size: 17px;
}
.next-btn {
  padding: 1rem 1.5rem;
  background: #f1b24f;
  text-align: center;
  border-radius: 7px;
  color: #fff;
  cursor: pointer;
  transition: 0.3s;
}
.next-btn.not-active {
  background: #707070;
  pointer-events: none;
}
.next-btn.active {
  background: #f1b24f;
  pointer-events: all;
}
.next-btn.download {
  text-decoration: none;
  font-weight: bold;
  padding: 1rem 2rem;
}
.next-btn.download:hover {
  color: #fff;
}
.next-btn.not-selected {
  pointer-events: none;
  background: #707070;
}
.next-btn.sm {
  width: 300px;
  padding: 2rem 3rem;
  cursor: pointer;
}
.back-btn {
  padding: 1rem 1.5rem;
  background: #707070;
  text-align: center;
  border-radius: 7px;
  color: #fff;
  cursor: pointer;
}
.gray {
  color: #707070;
}
.text-white {
  color: #fff;
}
.bg-yellow {
  background-color: #f1b24f;
}
.bg-gray {
  background-color: #707070;
}
.yellow {
  color: #f1b24f;
}
.btn.bg-yellow:hover {
  background-color: #f1b24f;
}
.semi-title {
  font-size: 20px;
}
.line-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 1rem;
  height: 50vh;
}

.vl {
  border-left: 1px solid #8d8d8d;
  height: 300px;
}
.input-email {
  border: none;
  padding: 0.5rem;
  border-radius: 7px;
  height: 75px;
  width: 400px;
  text-align: center;
  outline: none;
}
.border-input {
  border-radius: 7px;
}
.send-email {
  height: 75px;
  border-radius: 7px;
  margin-left: -10px;
  width: 100%;
  max-width: 150px;
  color: #fff;
}
.card-title {
  margin: 1rem 0;
  font-size: 1.12rem;
}

.selected-image {
  position: relative;
  width: 100%;
}
.selected-image .image {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}
.bugs.hide {
  display: none !important;
  opacity: 0;
  visibility: hidden;
}
.download.deleted {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 500px;
}
.not-found {
  color: #dbe2ed;
  font-size: 300px;
  line-height: 0.8em;
  font-weight: 700;
  opacity: 1;
  transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg)
    rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg);
  transform-style: preserve-3d;
}
.back {
  text-decoration: none;
}
.file-format {
  margin-top: 0.6rem;
}
.hide {
  display: none;
}
.tutorial-wp {
  position: absolute;
  top: 1.12rem;
  right: 1rem;
}
.tutorial {
  text-decoration: none;
  margin-left: 1rem;
}
.tutorial-icon {
  width: 30px;
  height: 30px;
}
.tutorial-modal .modal-content .modal-header .modal-title {
  width: 100%;
  text-align: center;
}
.tutorial-modal .modal-content .modal-body {
  display: flex;
  justify-content: center;
  align-items: center;
}
.captcha-wp {
  padding: 5px;
  background: linear-gradient(to bottom, #e0e0e0, #f0f0f0);
  border-radius: 5px;
  max-height: 55px;
  min-height: 55px;
  position: relative;
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
}

.captcha-wp::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  pointer-events: none;
}

.captcha-wp::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle, #000 1px, transparent 2px);
  background-size: 20px 20px;
  /* Adjust this to control dot density */
  opacity: 0.2;
  pointer-events: none;
}

.custom-text {
  font-size: 25px;
  color: #000;
  font-family: Arial, Helvetica, sans-serif;
  font-weight: bold;
  display: inline-block;
  transform: rotate(-2deg) scale(0.8);
  margin: 2px;
  letter-spacing: 7px;
  text-shadow: 2px 2px 3px rgba(0, 0, 0, 0.3);
  position: relative;
  transform: rotate(-5deg);

  &::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: repeating-linear-gradient(
      45deg,
      transparent,
      transparent 2px,
      #999 2px,
      #999 4px
    );
    opacity: 0.2;
  }
}
.random-1 {
  font-size: 31px;
}
.random-2 {
  font-size: 25px;
}
.random-3 {
  font-size: 33px;
}
.random-4 {
  font-size: 29px;
}
.refresh {
  -webkit-user-select: none;
          user-select: none;
}

.upload-btn {
  cursor: pointer;
  padding: 0.3rem 0.5rem;
  border-radius: 10px;
  min-height: 60px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
  width: 90%;
}
.upload-btn.sm {
  width: 50%;
}
.w-70 {
  width: 70%;
}
.modal {
  display: none;
}
.modal.show {
  display: block;
}
.modal-content.preview.advance-image {
  min-height: 500px;
}
.submit-advance-btn {
  width: 350px;
  text-align: center;
  padding: 0.8rem;
  border-radius: 10px;
  margin-top: 1rem;
  padding-top: 1rem;
}
.w-full {
  width: 100%;
}

.loading-wp {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
}

.loader {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: inline-block;
  border-top: 4px solid #000;
  border-right: 4px solid transparent;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

.loader::after {
  content: "";
  box-sizing: border-box;
  position: absolute;
  left: 0;
  top: 0;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border-left: 4px solid #f1b24f;
  border-bottom: 4px solid transparent;
  animation: rotation 0.5s linear infinite reverse;
}
.submit-advance-btn {
  border: none;
}
.mr-1 {
  margin-right: 0.44rem;
}
.ml-2-yt {
  margin-left: 0.9rem;
}
.dotted-divider {
  width: 3px;
  height: 100%; /* Adjust the height as needed */
  min-height: 25vh;
  border-left: 2px dotted gray; /* Adjust the color and size */
}
.color-box {
  width: 50px;
  height: 50px;
  border: 1px solid #000;
  border-radius: 6px;
  overflow: hidden;
}
.checkbox-remove-color {
  top: 0;
  right: 0;
  height: 25px;
  width: 25%;
}
.manual-image-adjustment {
  width: 100%;
  max-width: 350px;
  height: auto;
}

.modal-brandpatch .modal-lg .modal-content .modal-header .modal-title {
  text-align: center;
}
.modal-brandpatch .modal-lg .modal-content .modal-header .btn-close {
  position: absolute;
  top: 15px;
  right: 14px;
}
.image-b-container {
  position: relative;
  width: 100%;
  border: 1px solid rgba(212, 197, 197, 0.35);
  /* box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px; */
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-b-container img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  /* or object-fit: cover; */
}
.image-b-container .check-mark.selected {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
.lookbookselect {
  width: 100%;
  min-width: 25%;
}
.submit {
  padding: 1rem;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
}
/*RATINGS COMPONENT*/
.ratings-container {
  margin-top: 2.5rem;
  padding: 1rem;
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
  background: #fff;
  border-radius: 10px;
  max-width: 35%;
}
.rating-stars {
  font-size: 0;
}
.star {
  display: inline-block;
  margin-right: 0.6rem;
  width: 36px;
  height: 36px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat;
  background-size: cover;
  cursor: pointer;
}

.star.selected {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat;
  background-size: cover;
}

textarea {
  width: 100%;
  margin: 0px 0 10px;
  padding: 7px;
  border: 1px solid #9c9c9c;
  min-height: 120px;
  max-height: 215px;
  border-radius: 10px;
}
textarea:focus-visible {
  outline: none;
}
.next-btn.sm.ratings {
  height: 25px;
  padding: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.next-btn.sm.ratings.disabled {
  background-color: #707070;
  pointer-events: none;
}
.thank-you {
  padding: 1rem;

  border-radius: 10px;
}
.row.justify-content-center.min-h-100 {
  min-height: 50vh;
}
.checkbox-warning:focus {
  box-shadow: none;
  border-color: #ffbe00;
}
.checkbox-warning:checked {
  background-color: #ffbe00;
  border-color: #ffbe00;
}

.checkbox-warning:checked + .form-check-label {
  color: #000;
}

.checkbox-warning {
  background-color: #fff;
  border-color: #ddd;
}
.progress.h-progress {
  height: 0.7rem !important;
}
@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
@media (min-width: 1220px) {
  .back-btn {
    padding: 1.5rem 5rem;
    font-size: 0.9rem;
  }
  .back-btn.sm {
    padding: 1.9rem;
    font-size: 0.8rem;
  }
  .next-btn {
    padding: 1.5rem 5rem;
    font-size: 0.9rem;
  }
  .modal-brandpatch .modal-lg .modal-content {
    width: 1650px !important;
  }
  .logo {
    padding: 2rem;
  }
}
@media (min-width: 780px) {
  .modal {
    overflow: hidden;
  }
  .modal-content.preview {
    width: 60%;
  }
  .guide-modal .modal-content {
    width: 100%;
  }
  .h-500 {
    height: 500px;
  }
  .w-30 {
    width: 360px;
  }
}
@media (max-width: 1200px) {
  .modal-content.preview {
    max-height: 650px;
    overflow: scroll;
  }
  .line-container {
    display: none;
  }

  .image-preview {
    max-width: max-content;
  }

  .w-50 {
    width: 100% !important;
  }

  .w-70 {
    width: 100% !important;
  }
}
@media (max-width: 980px) {
  .ratings-container {
    max-width: 100%;
  }
}
@media (max-width: 980px) {
  .card-custom {
    width: 100%;
  }
}
@media (max-width: 779px) {
  .lookbook-list {
    flex-direction: column !important;
  }

  .box {
    width: 100%;
    max-width: none;
    min-width: auto;
    min-height: auto;
  }
  .disclaimer-text {
    width: 50%;
  }
  .guide-modal .circle::after {
    display: none;
  }
  .guide-modal .modal-title::after {
    display: none;
  }
  .tutorial {
    font-size: 12px;
  }
  .guide {
    font-size: 12px;
  }
  .guide .question {
    width: 15px;
    height: 15px;
  }
  .input-email {
    width: 100%;
    height: 50px;
  }
  .send-email {
    height: 50px;
  }
  .send-form-input {
    margin-top: 1.5rem;
  }

  .guide-modal .modal-title::after {
    display: none;
  }
  .tutorial {
    font-size: 12px;
  }

  .guide {
    font-size: 12px;
  }

  .guide .question {
    width: 15px;
    height: 15px;
  }

  .input-email {
    width: 100%;
    height: 50px;
  }

  .send-email {
    height: 50px;
    font-size: 13px;
  }

  .send-form-input {
    margin-top: 1.5rem;
  }
  .upload-modal-sm {
    flex-direction: column;
  }

  .thank-you {
    padding: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,MAAM;AACR;;AAEA;EACE,sEAAsE;EACtE,UAAU;AACZ;;AAEA;EACE,yDAA8C;EAC9C,UAAU;EACV,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB;;;;;;2DAMyD;EACzD,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,SAAS;EACT,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,iCAAiC;EACjC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,sDAAsD;AACxD;;AAEA;EACE,WAAW;AACb;;AAEA,QAAQ;AACR;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,MAAM;EACN,UAAU;AACZ;;AAEA;;EAEE,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;AACA;EACE;iBACe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yDAAwD;AAC1D;AACA;EACE,yBAAyB;AAC3B;AACA,qBAAqB;AACrB;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EAGzB,wBAAwB;AAC1B;;AAEA;EACE,iDAAiD;EACjD,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,2BAA2B;EAC3B,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,SAAS;EACT,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,SAAS,EAAE,kCAAkC;EAC7C,UAAU;EACV,0BAA0B;EAC1B,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,sBAAsB,EAAE,8BAA8B;EACtD,UAAU;EACV,UAAU;EACV,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,yDAA8C;EAC9C,4BAA4B;EAC5B,UAAU;EACV,SAAS;AACX;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,yDAAoD;EACpD,4BAA4B;EAC5B,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;AACA;EACE,sBAAsB;;EAEtB,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,aAAa;AACf;AACA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;AACZ;AACA;EACE,wBAAwB;EACxB,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV;gDAC8C;EAC9C,4BAA4B;AAC9B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,wDAAwD;EACxD,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8DAA8D;EAC9D,0BAA0B;EAC1B,uCAAuC;EACvC,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,yCAAyC;EACzC,iBAAiB;EACjB,qBAAqB;EACrB,mCAAmC;EACnC,WAAW;EACX,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,wBAAwB;;EAExB;IACE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;IACP;;;;;;KAMC;IACD,YAAY;EACd;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,0BAA0B;EAC1B,mCAAmC;EACnC,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,oCAAoC;EACpC,gDAAgD;AAClD;AACA;EACE,YAAY;AACd;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,YAAY,EAAE,gCAAgC;EAC9C,gBAAgB;EAChB,4BAA4B,EAAE,8BAA8B;AAC9D;AACA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,UAAU;AACZ;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,2CAA2C;EAC3C,uDAAuD;EACvD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,WAAW;EACX,cAAc;AAChB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,iDAAiD;AACnD;AACA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,aAAa;EACb,iDAAiD;EACjD,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,6DAAwD;EACxD,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,6DAAyD;EACzD,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,aAAa;;EAEb,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,oBAAoB;IACpB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,oBAAoB;IACpB,iBAAiB;EACnB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,iCAAiC;EACnC;;EAEA;IACE,WAAW;IACX,eAAe;IACf,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;EACA;IACE,sBAAsB;EACxB;;EAEA;IACE,UAAU;EACZ;AACF","sourcesContent":[".App-content {\n  position: relative;\n  z-index: 1;\n  padding-bottom: 1.5rem;\n  min-height: 76vh;\n}\n.topbar-wp {\n  position: relative;\n  background-color: #000;\n  z-index: 3;\n}\nheader {\n  position: relative;\n}\n.logo-wp {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\nfooter {\n  position: relative;\n}\n\n.orange {\n  color: #f1b24f;\n}\n\n.btn-orange {\n  background-color: #f1b24f !important;\n}\n\n.desc {\n  --text-opacity: 1;\n  color: rgb(75 85 99 / var(--text-opacity));\n}\n\n.bg {\n  width: 100%;\n  min-height: 100vh;\n  position: fixed;\n  display: flex;\n  justify-content: center;\n  padding: 120px 24px 160px;\n  pointer-events: none;\n}\n.noclick {\n  pointer-events: none;\n}\n.clickable {\n  pointer-events: all;\n}\n.bg::after,\n.bg::before {\n  position: absolute;\n  content: \"\";\n  width: 100%;\n  height: 100%;\n  top: 0;\n}\n\n.bg::before {\n  background: radial-gradient(circle, rgba(2, 0, 36, 0) 0, #fafafa 100%);\n  z-index: 2;\n}\n\n.bg::after {\n  background-image: url(/public/images/grid.svg);\n  z-index: 1;\n  opacity: 0.4;\n  filter: invert(1);\n}\n\n.gradient {\n  height: -moz-fit-content;\n  height: fit-content;\n  z-index: 3;\n  max-width: 640px;\n  background-image: radial-gradient(at 27% 37%, #fcb034 0, transparent 0),\n    radial-gradient(at 97% 21%, #72fe7d 0, transparent 50%),\n    radial-gradient(at 52% 99%, #fd3a4e 0, transparent 50%),\n    radial-gradient(at 10% 29%, #855afc 0, transparent 50%),\n    radial-gradient(at 97% 96%, #e4c795 0, transparent 50%),\n    radial-gradient(at 33% 50%, #8ca8e8 0, transparent 50%),\n    radial-gradient(at 79% 53%, #eea5ba 0, transparent 50%);\n  position: absolute;\n  content: \"\";\n  width: 100%;\n  height: 100%;\n  filter: blur(100px) saturate(10%);\n  top: 80px;\n  opacity: 0.1;\n}\n\n.box {\n  max-width: 840px;\n  min-width: 840px;\n  height: 100%;\n  min-height: 440px;\n  border-radius: 20px;\n  padding: 1rem 3rem;\n  border: 1px solid #000 !important;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.box.upload {\n  --bg-opacity: 1;\n  background-color: rgb(255 255 255 / var(--bg-opacity));\n}\n\n.card-group {\n  width: 100%;\n}\n\n/*Modal*/\n.modal {\n  display: none;\n  position: fixed;\n  /* z-index: 1; */\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  background-color: rgba(0, 0, 0, 0.4);\n}\n\n.modal.open {\n  display: block;\n}\n.product-logo-box {\n  height: 100%;\n  min-height: 35vh;\n  min-width: 25vw;\n}\n.product-logo-box.solo {\n  width: 28vw;\n  min-height: 35vh;\n}\n#advanceImage .modal-content {\n  margin: 50px auto;\n}\n.modal-content {\n  background-color: #fefefe;\n  margin: 10% auto;\n  padding: 20px;\n  width: 100%;\n}\n\n.close {\n  color: #aaa;\n  float: initial;\n  font-size: 28px;\n  font-weight: bold;\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  right: 8px;\n}\n\n.close:hover,\n.close:focus {\n  color: black;\n  text-decoration: none;\n  cursor: pointer;\n}\n.card-custom {\n  width: 350px;\n  height: auto;\n}\n.card-custom2 {\n  height: 20rem;\n}\n\n.image-preview {\n  width: 100%;\n  height: 290px;\n  object-fit: contain;\n}\n.filter-0 {\n  filter: brightness(0%);\n}\n.filter-100 {\n  filter: brightness(100%);\n}\n\n.filter-100 {\n  filter: brightness(100%);\n}\n.image-preview.three {\n  width: 100%;\n  height: 290px;\n  object-fit: contain;\n}\n.image-preview-gray {\n  filter: invert(57%) sepia(3%) saturate(27%) hue-rotate(4deg) brightness(10%)\n    contrast(89%);\n}\n.preview-image-background {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-image: url(/public/images/bg-transparent.jpg);\n}\n.margin-auto {\n  margin: 1rem 0 !important;\n}\n/*Customize Checkbox*/\n.checkbox-cont {\n  display: block;\n  position: relative;\n  padding-left: 31px;\n  margin-bottom: 12px;\n  cursor: pointer;\n  font-size: 15px;\n  -webkit-user-select: none;\n  user-select: none;\n}\n\n.checkbox-cont input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0;\n}\n\n.checkmark {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 25px;\n  width: 25px;\n  background-color: #eee;\n}\n\n.checkbox-cont:hover input ~ .checkmark {\n  background-color: #ccc;\n}\n\n.checkbox-cont input:checked ~ .checkmark {\n  background-color: #fcb034;\n}\n\n.checkmark:after {\n  content: \"\";\n  position: absolute;\n  display: none;\n}\n\n.checkbox-cont input:checked ~ .checkmark:after {\n  display: block;\n}\n\n.checkbox-cont .checkmark:after {\n  left: 10px;\n  top: 7px;\n  width: 5px;\n  height: 10px;\n  border: solid white;\n  border-width: 0 3px 3px 0;\n  -webkit-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n\nimg.card-img-top {\n  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);\n  max-height: 200px;\n  min-height: 200px;\n  border-radius: 7px;\n}\n.card-img-top-download {\n  max-width: 330px;\n  max-height: 260px;\n  min-height: 260px;\n  border-radius: 7px;\n}\n\n.container {\n  position: relative;\n  z-index: 0;\n}\n\n.customize {\n  position: fixed !important;\n  min-height: 133vh;\n  overflow: hidden !important;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: -1;\n}\n\n._loading_overlay_wrapper--active {\n  z-index: 11 !important;\n}\n\n.check {\n  color: #f1b24f;\n  font-size: 3rem;\n  font-weight: bold;\n  position: absolute;\n  top: -15px;\n  left: 5px;\n  display: none;\n}\n.check-mark {\n  width: 45px;\n  height: 45px;\n  border-radius: 10px;\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background-color: #fff;\n  border: 1px solid #000;\n}\n.check-mark.brand {\n  background-color: transparent;\n}\n.check-mark.selected .check {\n  display: block;\n}\n.step-one-label {\n  font-weight: bold;\n}\n.info-label {\n  font-size: 15px;\n  width: 350px;\n}\n.disclaimer-cont {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.disclaimer-cont .h-50 {\n  height: 500px;\n}\n.disclaimer-text {\n  text-align: center;\n  font-style: italic;\n  font-weight: bold;\n  width: 40%;\n  margin-top: 1rem;\n  max-width: 100%;\n}\n.space-between {\n  justify-content: space-between;\n}\n.guide-wp {\n  top: 1rem;\n  right: 3.5rem;\n}\n.guide {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 10%;\n  padding: 0.2rem;\n}\n.guide.tutorial:hover .tooltip {\n  visibility: visible;\n  opacity: 1;\n}\n.tutorial-wp:hover .tutorial .tooltip {\n  visibility: visible;\n  opacity: 1;\n}\n.tooltip {\n  visibility: hidden;\n  position: absolute;\n  top: 20px; /* Adjust the position as needed */\n  left: -10%;\n  transform: translateY(50%);\n  background-color: white;\n  color: black;\n  border-radius: 10px;\n  padding: 5px 10px;\n  font-size: 12px;\n  border: 1px solid #ccc; /* Light border for contrast */\n  z-index: 1;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n.question {\n  width: 30px;\n  height: 30px;\n}\n.guide-modal .bold {\n  font-weight: bold;\n}\n\n.guide-modal .modal-header {\n  display: block;\n  border-bottom: none;\n}\n.guide-modal .modal-title {\n  text-align: center;\n  color: black;\n  position: relative;\n}\n.guide-modal .modal-title::after {\n  content: \"\";\n  position: absolute;\n  width: 356px;\n  height: 30px;\n  background-image: url(/public/images/line.svg);\n  background-repeat: no-repeat;\n  right: 33%;\n  top: 35px;\n}\n.guide-modal .circle {\n  position: relative;\n}\n.guide-modal .circle::after {\n  content: \"\";\n  position: absolute;\n  width: 408.38px;\n  height: 100px;\n  background-image: url(/public/images/circle-one.svg);\n  background-repeat: no-repeat;\n  right: 27%;\n  top: -40px;\n}\n\n.guide-modal .btn-close {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n}\n.info-desc {\n  padding: 0.5rem 0.6rem;\n\n  border-radius: 10px;\n}\n.info-desc p {\n  font-size: 14px;\n}\n\n.new {\n  position: relative;\n  color: #fff;\n  background-color: #ffcc00;\n  margin-left: 1rem;\n  display: block;\n  font-size: 0.8rem;\n  text-align: center;\n  border-radius: var(--bs-card-border-radius);\n  padding: 0.1rem 1.2rem;\n  margin-top: 1rem;\n}\n.new::after {\n  content: \"\";\n  position: absolute;\n  top: 65%;\n  left: 3.3px;\n  background-color: #ffcc00;\n  border: 1px solid #ffcc00;\n  width: 15px;\n  height: 15px;\n  transform: rotate(45deg);\n  border-top: none;\n  border-left: none;\n}\n.modal-iframe .modal-dialog {\n  max-width: 100%;\n  height: 100%;\n}\n\niframe.preview-iframe {\n  width: 100%;\n  height: 75vh;\n}\n.add-image-icon {\n  width: 70px;\n  height: 70px;\n}\n.preview-catalog {\n  width: 100%;\n  text-align: center;\n  background: #f1b24f;\n  border-radius: 7px;\n  padding: 0.5rem;\n  color: #fff;\n  font-weight: bold;\n  font-size: 17px;\n}\n.next-btn {\n  padding: 1rem 1.5rem;\n  background: #f1b24f;\n  text-align: center;\n  border-radius: 7px;\n  color: #fff;\n  cursor: pointer;\n  transition: 0.3s;\n}\n.next-btn.not-active {\n  background: #707070;\n  pointer-events: none;\n}\n.next-btn.active {\n  background: #f1b24f;\n  pointer-events: all;\n}\n.next-btn.download {\n  text-decoration: none;\n  font-weight: bold;\n  padding: 1rem 2rem;\n}\n.next-btn.download:hover {\n  color: #fff;\n}\n.next-btn.not-selected {\n  pointer-events: none;\n  background: #707070;\n}\n.next-btn.sm {\n  width: 300px;\n  padding: 2rem 3rem;\n  cursor: pointer;\n}\n.back-btn {\n  padding: 1rem 1.5rem;\n  background: #707070;\n  text-align: center;\n  border-radius: 7px;\n  color: #fff;\n  cursor: pointer;\n}\n.gray {\n  color: #707070;\n}\n.text-white {\n  color: #fff;\n}\n.bg-yellow {\n  background-color: #f1b24f;\n}\n.bg-gray {\n  background-color: #707070;\n}\n.yellow {\n  color: #f1b24f;\n}\n.btn.bg-yellow:hover {\n  background-color: #f1b24f;\n}\n.semi-title {\n  font-size: 20px;\n}\n.line-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0 1rem;\n  height: 50vh;\n}\n\n.vl {\n  border-left: 1px solid #8d8d8d;\n  height: 300px;\n}\n.input-email {\n  border: none;\n  padding: 0.5rem;\n  border-radius: 7px;\n  height: 75px;\n  width: 400px;\n  text-align: center;\n  outline: none;\n}\n.border-input {\n  border-radius: 7px;\n}\n.send-email {\n  height: 75px;\n  border-radius: 7px;\n  margin-left: -10px;\n  width: 100%;\n  max-width: 150px;\n  color: #fff;\n}\n.card-title {\n  margin: 1rem 0;\n  font-size: 1.12rem;\n}\n\n.selected-image {\n  position: relative;\n  width: 100%;\n}\n.selected-image .image {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1;\n}\n.bugs.hide {\n  display: none !important;\n  opacity: 0;\n  visibility: hidden;\n}\n.download.deleted {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 500px;\n}\n.not-found {\n  color: #dbe2ed;\n  font-size: 300px;\n  line-height: 0.8em;\n  font-weight: 700;\n  opacity: 1;\n  transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg)\n    rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg);\n  transform-style: preserve-3d;\n}\n.back {\n  text-decoration: none;\n}\n.file-format {\n  margin-top: 0.6rem;\n}\n.hide {\n  display: none;\n}\n.tutorial-wp {\n  position: absolute;\n  top: 1.12rem;\n  right: 1rem;\n}\n.tutorial {\n  text-decoration: none;\n  margin-left: 1rem;\n}\n.tutorial-icon {\n  width: 30px;\n  height: 30px;\n}\n.tutorial-modal .modal-content .modal-header .modal-title {\n  width: 100%;\n  text-align: center;\n}\n.tutorial-modal .modal-content .modal-body {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.captcha-wp {\n  padding: 5px;\n  background: linear-gradient(to bottom, #e0e0e0, #f0f0f0);\n  border-radius: 5px;\n  max-height: 55px;\n  min-height: 55px;\n  position: relative;\n  pointer-events: none;\n  user-select: none;\n}\n\n.captcha-wp::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: transparent;\n  pointer-events: none;\n}\n\n.captcha-wp::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: radial-gradient(circle, #000 1px, transparent 2px);\n  background-size: 20px 20px;\n  /* Adjust this to control dot density */\n  opacity: 0.2;\n  pointer-events: none;\n}\n\n.custom-text {\n  font-size: 25px;\n  color: #000;\n  font-family: Arial, Helvetica, sans-serif;\n  font-weight: bold;\n  display: inline-block;\n  transform: rotate(-2deg) scale(0.8);\n  margin: 2px;\n  letter-spacing: 7px;\n  text-shadow: 2px 2px 3px rgba(0, 0, 0, 0.3);\n  position: relative;\n  transform: rotate(-5deg);\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    background: repeating-linear-gradient(\n      45deg,\n      transparent,\n      transparent 2px,\n      #999 2px,\n      #999 4px\n    );\n    opacity: 0.2;\n  }\n}\n.random-1 {\n  font-size: 31px;\n}\n.random-2 {\n  font-size: 25px;\n}\n.random-3 {\n  font-size: 33px;\n}\n.random-4 {\n  font-size: 29px;\n}\n.refresh {\n  user-select: none;\n}\n\n.upload-btn {\n  cursor: pointer;\n  padding: 0.3rem 0.5rem;\n  border-radius: 10px;\n  min-height: 60px;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-grow: 1;\n  width: 90%;\n}\n.upload-btn.sm {\n  width: 50%;\n}\n.w-70 {\n  width: 70%;\n}\n.modal {\n  display: none;\n}\n.modal.show {\n  display: block;\n}\n.modal-content.preview.advance-image {\n  min-height: 500px;\n}\n.submit-advance-btn {\n  width: 350px;\n  text-align: center;\n  padding: 0.8rem;\n  border-radius: 10px;\n  margin-top: 1rem;\n  padding-top: 1rem;\n}\n.w-full {\n  width: 100%;\n}\n\n.loading-wp {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n}\n\n.loader {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  display: inline-block;\n  border-top: 4px solid #000;\n  border-right: 4px solid transparent;\n  box-sizing: border-box;\n  animation: rotation 1s linear infinite;\n}\n\n.loader::after {\n  content: \"\";\n  box-sizing: border-box;\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  border-left: 4px solid #f1b24f;\n  border-bottom: 4px solid transparent;\n  animation: rotation 0.5s linear infinite reverse;\n}\n.submit-advance-btn {\n  border: none;\n}\n.mr-1 {\n  margin-right: 0.44rem;\n}\n.ml-2-yt {\n  margin-left: 0.9rem;\n}\n.dotted-divider {\n  width: 3px;\n  height: 100%; /* Adjust the height as needed */\n  min-height: 25vh;\n  border-left: 2px dotted gray; /* Adjust the color and size */\n}\n.color-box {\n  width: 50px;\n  height: 50px;\n  border: 1px solid #000;\n  border-radius: 6px;\n  overflow: hidden;\n}\n.checkbox-remove-color {\n  top: 0;\n  right: 0;\n  height: 25px;\n  width: 25%;\n}\n.manual-image-adjustment {\n  width: 100%;\n  max-width: 350px;\n  height: auto;\n}\n\n.modal-brandpatch .modal-lg .modal-content .modal-header .modal-title {\n  text-align: center;\n}\n.modal-brandpatch .modal-lg .modal-content .modal-header .btn-close {\n  position: absolute;\n  top: 15px;\n  right: 14px;\n}\n.image-b-container {\n  position: relative;\n  width: 100%;\n  border: 1px solid rgba(212, 197, 197, 0.35);\n  /* box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px; */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.image-b-container img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  /* or object-fit: cover; */\n}\n.image-b-container .check-mark.selected {\n  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n}\n.lookbookselect {\n  width: 100%;\n  min-width: 25%;\n}\n.submit {\n  padding: 1rem;\n  background: #fff;\n  border-radius: 10px;\n  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);\n}\n/*RATINGS COMPONENT*/\n.ratings-container {\n  margin-top: 2.5rem;\n  padding: 1rem;\n  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);\n  background: #fff;\n  border-radius: 10px;\n  max-width: 35%;\n}\n.rating-stars {\n  font-size: 0;\n}\n.star {\n  display: inline-block;\n  margin-right: 0.6rem;\n  width: 36px;\n  height: 36px;\n  background: url(/public/images/star-empty.png) no-repeat;\n  background-size: cover;\n  cursor: pointer;\n}\n\n.star.selected {\n  background: url(/public/images/star-filled.png) no-repeat;\n  background-size: cover;\n}\n\ntextarea {\n  width: 100%;\n  margin: 0px 0 10px;\n  padding: 7px;\n  border: 1px solid #9c9c9c;\n  min-height: 120px;\n  max-height: 215px;\n  border-radius: 10px;\n}\ntextarea:focus-visible {\n  outline: none;\n}\n.next-btn.sm.ratings {\n  height: 25px;\n  padding: 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.next-btn.sm.ratings.disabled {\n  background-color: #707070;\n  pointer-events: none;\n}\n.thank-you {\n  padding: 1rem;\n\n  border-radius: 10px;\n}\n.row.justify-content-center.min-h-100 {\n  min-height: 50vh;\n}\n.checkbox-warning:focus {\n  box-shadow: none;\n  border-color: #ffbe00;\n}\n.checkbox-warning:checked {\n  background-color: #ffbe00;\n  border-color: #ffbe00;\n}\n\n.checkbox-warning:checked + .form-check-label {\n  color: #000;\n}\n\n.checkbox-warning {\n  background-color: #fff;\n  border-color: #ddd;\n}\n.progress.h-progress {\n  height: 0.7rem !important;\n}\n@keyframes rotation {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n@media (min-width: 1220px) {\n  .back-btn {\n    padding: 1.5rem 5rem;\n    font-size: 0.9rem;\n  }\n  .back-btn.sm {\n    padding: 1.9rem;\n    font-size: 0.8rem;\n  }\n  .next-btn {\n    padding: 1.5rem 5rem;\n    font-size: 0.9rem;\n  }\n  .modal-brandpatch .modal-lg .modal-content {\n    width: 1650px !important;\n  }\n  .logo {\n    padding: 2rem;\n  }\n}\n@media (min-width: 780px) {\n  .modal {\n    overflow: hidden;\n  }\n  .modal-content.preview {\n    width: 60%;\n  }\n  .guide-modal .modal-content {\n    width: 100%;\n  }\n  .h-500 {\n    height: 500px;\n  }\n  .w-30 {\n    width: 360px;\n  }\n}\n@media (max-width: 1200px) {\n  .modal-content.preview {\n    max-height: 650px;\n    overflow: scroll;\n  }\n  .line-container {\n    display: none;\n  }\n\n  .image-preview {\n    max-width: max-content;\n  }\n\n  .w-50 {\n    width: 100% !important;\n  }\n\n  .w-70 {\n    width: 100% !important;\n  }\n}\n@media (max-width: 980px) {\n  .ratings-container {\n    max-width: 100%;\n  }\n}\n@media (max-width: 980px) {\n  .card-custom {\n    width: 100%;\n  }\n}\n@media (max-width: 779px) {\n  .lookbook-list {\n    flex-direction: column !important;\n  }\n\n  .box {\n    width: 100%;\n    max-width: none;\n    min-width: auto;\n    min-height: auto;\n  }\n  .disclaimer-text {\n    width: 50%;\n  }\n  .guide-modal .circle::after {\n    display: none;\n  }\n  .guide-modal .modal-title::after {\n    display: none;\n  }\n  .tutorial {\n    font-size: 12px;\n  }\n  .guide {\n    font-size: 12px;\n  }\n  .guide .question {\n    width: 15px;\n    height: 15px;\n  }\n  .input-email {\n    width: 100%;\n    height: 50px;\n  }\n  .send-email {\n    height: 50px;\n  }\n  .send-form-input {\n    margin-top: 1.5rem;\n  }\n\n  .guide-modal .modal-title::after {\n    display: none;\n  }\n  .tutorial {\n    font-size: 12px;\n  }\n\n  .guide {\n    font-size: 12px;\n  }\n\n  .guide .question {\n    width: 15px;\n    height: 15px;\n  }\n\n  .input-email {\n    width: 100%;\n    height: 50px;\n  }\n\n  .send-email {\n    height: 50px;\n    font-size: 13px;\n  }\n\n  .send-form-input {\n    margin-top: 1.5rem;\n  }\n  .upload-modal-sm {\n    flex-direction: column;\n  }\n\n  .thank-you {\n    padding: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
